import { isPresent } from "@/lib/utils"

export default {
  namespaced: true,

  state: {
    appSubscription: null
  },

  mutations: {
    setAppSubscription(state, subscription) {
      state.appSubscription = isPresent(subscription) ? subscription : null
    }
  },

  getters: {
    requiresAuthentication(_, __, state) {
      return state.global?.access.require_sign_in
    },

    isSubscriberOnly(_, __, state) {
      return state.global?.access.is_subscriber_only
    },

    isSubscribedToApp(state, __, ___, getters) {
      if (getters["auth/isAuthenticated"]) {
        return !!state.appSubscription
      } else {
        return false
      }
    },

    hasAccessViaSubscription(_, getters) {
      return getters.isSubscriberOnly && getters.isSubscribedToApp
    },

    appPurchaseOverlayId(_, __, state) {
      return state.global?.access.purchase_overlay?.id
    },

    allowsAnonymousBrowsing(_, __, state) {
      return !!state.global?.access.allow_anonymous_browsing
    }
  }
}
